import { SupportUrls } from 'domains/support/SupportUrls'

import { basicApi } from './requester'

export const getSupportUrls = () => {
  return basicApi.get<SupportUrls>(`/support/urls`).then((response) => response.data)
}
